import React, { useState, useEffect } from 'react';
import PainelFaturasTelefonia from '../components/PainelFaturasTelefonia';
import PainelFaturasServico from '../components/PainelFaturasServico';
import { Briefcase, Save } from 'lucide-react';

const API = '/api/servicos';
function getToken() { return localStorage.getItem('synapse_token'); }
async function api(method, body) {
    const res = await fetch(API, { method, headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + getToken() }, body: body ? JSON.stringify(body) : undefined });
    return res.json();
}

const PRODUTOS = [
    { id: 'telefonia', nome: 'Telefonia', temValor: false, temConsumo: false },
    { id: 'synapse', nome: 'Synapse', temValor: true, temConsumo: true },
    { id: 'marketing', nome: 'Marketing', temValor: true, temConsumo: false },
];

const S = {
    page: { padding: 28, color: '#e8e8f0' },
    card: { background: '#181826', border: '1px solid #2a2a3e', borderRadius: 12, padding: 20, marginBottom: 16, maxWidth: 680 },
    label: { display: 'block', fontSize: 13, color: '#9a9ab0', marginBottom: 4, marginTop: 12 },
    input: { width: '100%', maxWidth: 320, padding: '8px 10px', background: '#10101c', border: '1px solid #2a2a3e', borderRadius: 8, color: '#e8e8f0' },
    btn: { display: 'inline-flex', alignItems: 'center', gap: 6, marginTop: 14, padding: '8px 16px', background: '#5b5bd6', border: 'none', borderRadius: 8, color: '#fff', cursor: 'pointer' },
};

export default function Servicos() {
    const [clientes, setClientes] = useState([]);
    const [servicos, setServicos] = useState({});
    const [sel, setSel] = useState('');
    const [msg, setMsg] = useState('');
    const [venc, setVenc] = useState(''); const [vencMsg, setVencMsg] = useState('');

    useEffect(() => { carregar(); }, []);
    async function carregar() {
        const [cs, ss] = await Promise.all([
            fetch('/api/clientes', { headers: { 'Authorization': 'Bearer ' + getToken() } }).then(r => r.json()),
            api('GET')
        ]);
        setClientes(Array.isArray(cs) ? cs : []);
        const m = {};
        (Array.isArray(ss) ? ss : []).forEach(s => { m[s.cliente_id + '|' + s.produto] = s; });
        setServicos(m);
        try { const rv = await fetch('/api/servicos/config/vencimento', { headers: { 'Authorization': 'Bearer ' + getToken() } }).then(r => r.json()); if (rv && rv.dia) setVenc(String(rv.dia)); } catch (e) { setVencMsg('erro|Erro ao ler vencimento'); }
        try { const rp = await fetch('/api/servicos/config/pix', { headers: { 'Authorization': 'Bearer ' + getToken() } }).then(r => r.json()); if (rp && rp.pix) setPix({ tipo: rp.pix.tipo || 'celular', chave: rp.pix.chave || '', nome: rp.pix.nome || '', cidade: rp.pix.cidade || '' }); else if (rp && rp.error) setPixMsg('erro|' + rp.error); } catch (e) { setPixMsg('erro|Erro ao ler a chave Pix'); }
    }
    const [pix, setPix] = useState({ tipo: 'celular', chave: '', nome: '', cidade: '' }); // Pix nas faturas 27/10/2026
    const [pixMsg, setPixMsg] = useState('');
    async function salvarPix() {
        setPixMsg('');
        try {
            const r = await fetch('/api/servicos/config/pix', { method: 'PUT', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + getToken() }, body: JSON.stringify(pix) });
            const j = await r.json();
            if (r.ok) { if (j.pix) setPix(j.pix); setPixMsg(j.pix ? 'ok|Salvo com sucesso' : 'ok|Pix removido das faturas'); } else setPixMsg('erro|' + (j.error || 'Erro ao salvar'));
        } catch (e) { setPixMsg('erro|Erro ao salvar'); }
    }
    async function salvarVenc() {
        setVencMsg('');
        try {
            const r = await fetch('/api/servicos/config/vencimento', { method: 'PUT', headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + getToken() }, body: JSON.stringify({ dia: venc }) });
            const j = await r.json();
            if (r.ok) { setVenc(String(j.dia)); setVencMsg('ok|Salvo com sucesso'); } else setVencMsg('erro|' + (j.error || 'Erro ao salvar'));
        } catch (e) { setVencMsg('erro|Erro ao salvar'); }
    }
    function campo(prod, c) {
        const s = servicos[sel + '|' + prod];
        if (s && s[c] !== null && s[c] !== undefined) return s[c];
        return (c === 'fatura_whatsapp' || c === 'relatorio_consumo') ? false : '';
    }
    function setCampo(prod, c, v) {
        setServicos(p => ({ ...p, [sel + '|' + prod]: { ...(p[sel + '|' + prod] || { cliente_id: sel, produto: prod }), [c]: v } }));
    }
    async function salvar(prod) {
        const s = servicos[sel + '|' + prod] || { cliente_id: sel, produto: prod };
        const r = await api('PUT', {
            cliente_id: sel, produto: prod,
            valor_mensal: s.valor_mensal === '' ? null : s.valor_mensal,
            servicos_incluidos: s.servicos_incluidos || null,
            relatorio_consumo: !!s.relatorio_consumo,
            fatura_whatsapp: !!s.fatura_whatsapp,
            fatura_dia_envio: s.fatura_dia_envio === '' ? null : s.fatura_dia_envio,
            fatura_minuto_envio: (s.fatura_minuto_envio === '' || s.fatura_minuto_envio === null || s.fatura_minuto_envio === undefined) ? null : s.fatura_minuto_envio,
        });
        if (r && r.id) { setServicos(p => ({ ...p, [sel + '|' + prod]: r })); setMsg(prod + '|Salvo com sucesso'); }
        else { setMsg(prod + '|Erro ao salvar' + (r && r.error ? ' - ' + r.error : '')); }
        setTimeout(() => setMsg(''), 3000);
    }

    return (
        <div style={S.page}>
            <h1 style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 26 }}><Briefcase size={26} /> Servicos</h1>
            <p style={{ color: '#9a9ab0', marginBottom: 20 }}>Servicos contratados e envio de fatura por produto</p>
            <div style={{ ...S.card, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                <b>Dia de vencimento (todas as faturas)</b>
                <input type="number" min="1" max="28" value={venc} onChange={e => setVenc(e.target.value)} style={{ ...S.input, maxWidth: 90 }} />
                <button style={S.btn} onClick={salvarVenc}>Salvar vencimento</button>
                {vencMsg && <span style={{ color: vencMsg.indexOf('erro|') === 0 ? '#ff7b7b' : '#7bff9e' }}>{vencMsg.split('|')[1]}</span>}
            </div>
            <div style={{ ...S.card, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                <b>Pix nas faturas</b>
                <select value={pix.tipo} onChange={e => setPix({ ...pix, tipo: e.target.value })} style={{ ...S.input, maxWidth: 130 }}>
                    <option value="celular">Celular</option>
                    <option value="cpf">CPF</option>
                    <option value="cnpj">CNPJ</option>
                    <option value="email">E-mail</option>
                    <option value="aleatoria">Aleatória</option>
                </select>
                <input placeholder="Chave Pix (vazio = sem Pix)" value={pix.chave} onChange={e => setPix({ ...pix, chave: e.target.value })} style={{ ...S.input, maxWidth: 220 }} />
                <input placeholder="Nome do recebedor" value={pix.nome} onChange={e => setPix({ ...pix, nome: e.target.value })} style={{ ...S.input, maxWidth: 200 }} />
                <input placeholder="Cidade" value={pix.cidade} onChange={e => setPix({ ...pix, cidade: e.target.value })} style={{ ...S.input, maxWidth: 140 }} />
                <button style={S.btn} onClick={salvarPix}>Salvar Pix</button>
                {pixMsg && <span style={{ color: pixMsg.indexOf('erro|') === 0 ? '#ff7b7b' : '#7bff9e' }}>{pixMsg.split('|')[1]}</span>}
            </div>
            <select value={sel} onChange={e => setSel(e.target.value)} style={{ ...S.input, marginBottom: 20 }}>
                <option value="">Selecione o cliente...</option>
                {clientes.map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
            </select>
            
            {sel && PRODUTOS.map(p => (
                <div key={p.id} style={{ ...S.card, maxWidth: 1180, display: 'flex', gap: 28, alignItems: 'flex-start', flexWrap: 'wrap' }}>
                <div style={{ flex: '1 1 380px', minWidth: 0 }}>
                    <h3 style={{ margin: 0, fontSize: 18 }}>{p.nome}</h3>
                    {p.id === 'telefonia' && <p style={{ color: '#9a9ab0', fontSize: 13, marginTop: 6 }}>Valor e detalhe vem do fechamento de minutos. Aqui so o envio por WhatsApp.</p>}
                    {p.temValor && (<>
                        <label style={S.label}>Valor mensal (R$)</label>
                        <input type="number" step="0.01" style={S.input} value={campo(p.id, 'valor_mensal')} onChange={e => setCampo(p.id, 'valor_mensal', e.target.value)} />
                        <label style={S.label}>Servicos incluidos (um por linha)</label>
                        <textarea rows={4} style={{ ...S.input, maxWidth: 480 }} value={campo(p.id, 'servicos_incluidos')} onChange={e => setCampo(p.id, 'servicos_incluidos', e.target.value)} />
                    </>)}
                    {p.temConsumo && (
                        <label style={{ ...S.label, display: 'flex', alignItems: 'center', gap: 8 }}>
                            <input type="checkbox" style={{ width: 16, height: 16, margin: 0 }} checked={!!campo(p.id, 'relatorio_consumo')} onChange={e => setCampo(p.id, 'relatorio_consumo', e.target.checked)} />
                            Relatorio detalhado de consumo na fatura
                        </label>
                    )}
                    <label style={{ ...S.label, display: 'flex', alignItems: 'center', gap: 8 }}>
                        <input type="checkbox" style={{ width: 16, height: 16, margin: 0 }} checked={!!campo(p.id, 'fatura_whatsapp')} onChange={e => setCampo(p.id, 'fatura_whatsapp', e.target.checked)} />
                        Enviar fatura por WhatsApp
                    </label>
                    <label style={S.label}>Dia de envio (1-28, vazio = dia do fechamento)</label>
                    <input type="number" min="1" max="28" style={{ ...S.input, maxWidth: 120 }} value={campo(p.id, 'fatura_dia_envio')} onChange={e => setCampo(p.id, 'fatura_dia_envio', e.target.value)} />
                    <label style={S.label}>Horario de envio (vazio = 09:00)</label>
                    <input type="time" style={{ ...S.input, maxWidth: 140 }} value={(function(){ var m = campo(p.id, 'fatura_minuto_envio'); if (m === '' || m === null) return ''; m = +m; return String(Math.floor(m/60)).padStart(2,'0') + ':' + String(m%60).padStart(2,'0'); })()} onChange={e => setCampo(p.id, 'fatura_minuto_envio', e.target.value ? (+e.target.value.split(':')[0])*60 + (+e.target.value.split(':')[1]) : '')} />
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}><button style={S.btn} onClick={() => salvar(p.id)}><Save size={16} /> Salvar {p.nome}</button>{msg.indexOf(p.id + '|') === 0 && <span style={{ marginTop: 14, color: msg.indexOf('Erro') > -1 ? '#ff7b7b' : '#7bff9e' }}>{msg.split('|')[1]}</span>}</div>
                </div>
                {p.id === 'telefonia' && (<div style={{ flex: '1 1 340px', minWidth: 0, borderLeft: '1px solid rgba(255,255,255,0.08)', paddingLeft: 24 }}><PainelFaturasTelefonia clienteId={sel} /></div>)}
                {(p.id === 'synapse' || p.id === 'marketing') && (<div style={{ flex: '1 1 340px', minWidth: 0, borderLeft: '1px solid rgba(255,255,255,0.08)', paddingLeft: 24 }}><PainelFaturasServico clienteId={sel} produto={p.id} /></div>)}

                </div>
            ))}
        </div>
    );
}
